import ForwardIcon from "@mui/icons-material/Forward";
import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";

export default function NextTerritory({
  boundaryInfo,
  openFromBoundary,
  terId,
}) {
  return (
    boundaryInfo.active &&
    boundaryInfo.data &&
    boundaryInfo.data.id !== terId && (
      <div
        className="mapTitle"
        onClick={openFromBoundary}
        style={{
          position: "absolute",
          bottom: 10,
          left: 10,
          zIndex: 100,
          padding: 10,
          display: "flex",
          flexDirection: "row",
          gap: 5,
          cursor: "pointer",
        }}
      >
        <MiniButton Icon={ForwardIcon} color={colorsList.blue} iconSize={20} />
        <div>{boundaryInfo.data.name}</div>
      </div>
    )
  );
}
